import { useTheme } from "app/shared";
import { getYoutubeVideoId } from "app/utils/getYoutubeId";
import { FC } from "react";
import styles from "./ProjectDetails.module.scss";

interface IProjectDetails {
  title: string;
  description: string;
  subtitle?: string;
  youtubeLink?: string;
  isLoading: boolean;
  imageUrl?: string;
}

const ProjectDetails: FC<IProjectDetails> = ({
  title,
  description,
  subtitle,
  youtubeLink,
  imageUrl,
}) => {
  const { theme } = useTheme();

  return (
    <div
      className={`${styles.infoSection} ${
        theme === "dark" ? styles.darkTheme : ""
      }`}
    >
      <h3
        className={`${styles.title} ${
          theme === "dark" ? styles.darkTheme : ""
        }`}
      >
        {title}
      </h3>
      {subtitle && (
        <h4
          className={styles.subtitle}
          dangerouslySetInnerHTML={{ __html: subtitle }}
        />
      )}

      {imageUrl ? (
        <>
          <p
            className={`${styles.description} ${
              theme === "dark" ? styles.darkTheme : ""
            }`}
            dangerouslySetInnerHTML={{ __html: description.slice(0, 1310) }}
          />
          <div className={styles.imageContainer}>
            <img
              src={imageUrl}
              alt="Project visual"
              className={styles.centeredImage}
            />
          </div>
          <p
            className={`${styles.description} ${
              theme === "dark" ? styles.darkTheme : ""
            }`}
            dangerouslySetInnerHTML={{ __html: description.slice(1310) }}
          />
        </>
      ) : (
        <p
          className={`${styles.description} ${
            theme === "dark" ? styles.darkTheme : ""
          }`}
          dangerouslySetInnerHTML={{ __html: description }}
        />
      )}
      {youtubeLink && (
        <div className={styles.youtubeWrapper}>
          <iframe
            width="560"
            height="315"
            src={`https://www.youtube.com/embed/${getYoutubeVideoId(
              youtubeLink
            )}`}
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          ></iframe>
        </div>
      )}
    </div>
  );
};

export default ProjectDetails;
